import React from 'react'
import './css/header.css'
import HomeIcon from '@material-ui/icons/Home';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import SearchIcon from '@material-ui/icons/Search';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import request from '../components/request'

function Header({ setSelectedOption }) {
    return (
        <div className='header'>

        <div className='header_icons' >
            <div className="header_icon header_icon--active">
            <HomeIcon />
            <p>Home</p>
            </div>
            <div  className="header_icon">
            <FlashOnIcon onClick={() => setSelectedOption(request.fetchTrending)}  />
            <p onClick={() => setSelectedOption(request.fetchTrending)} >Trending</p>
            </div>
            <div className="header_icon">
            <LiveTvIcon />
            <p>Live TV</p>
            </div>
            <div className="header_icon">
            <VideoLibraryIcon />
            <p>Series</p>
            </div>
            {/* <div className="header_icon">
            <SearchIcon />
            <p>Search</p>
            </div > */}
            <div className="header_icon">
            <PersonOutlineIcon />
            <p>Account</p>
            </div>  
            
        </div>

        <img  src='https://storage.googleapis.com/etransfer/fslogo.png' />
        </div>
    )
}

export default Header
